import React, { useState } from "react"
import { Link, useNavigate } from "react-router"
import { useTranslation } from 'react-i18next'

import { GUESTPOST, httpOk } from 'helpers/api'
import { notify, regexLogin } from "helpers/helpers"
import logo from 'assets/images/logo_icon.png'

function ForgotPassword() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const [user, setUser] = useState({ "login": "", "otp": "", "password": "" })
	const [show, setShow] = useState(false)
	const [showPassword, setShowPassword] = useState(false)
	const [error, setError] = useState('')
	const [loading, setLoading] = useState(false)

	function updateUser(name, value) {
		if (error) setError('')
		setUser((prev) => ({ ...prev, [name]: value }))
	}

	async function sendConfirmationCode() {
		if (loading) return

		if (!user.login) {
			setError(t('fill_login'))
			return
		}

		setError('')
		setLoading(true)
		const response = await GUESTPOST('/send-confirmation-code', user, { notification: false })
		setLoading(false)

		if (!response) {
			setError(t('no_server_connection'))
			return
		}

		if (!httpOk(response)) {
			setError(response?.data?.message || t('error'))
			return
		}

		setShow(true)
	}

	async function changePassword() {
		if (loading) return

		// Пароль тримим так же, как на входе: иначе пробел в конце попадёт в хэш,
		// а войти с ним потом будет нельзя — Login.js его срезает.
		const password = user.password.trim()
		if (!user.otp || !password) {
			setError(t('fill_code_and_password'))
			return
		}

		setError('')
		setLoading(true)
		const response = await GUESTPOST('/change-password', { ...user, password }, { notification: false })
		setLoading(false)

		if (!response) {
			setError(t('no_server_connection'))
			return
		}

		if (!httpOk(response)) {
			setError(response?.data?.message || t('error'))
			return
		}

		notify(t('data_succesfully_changed'), 'success')
		navigate("/auth/login")
	}

	function handleSubmit(e) {
		e.preventDefault()
		if (show) changePassword()
		else sendConfirmationCode()
	}

	return (
		<div className="auth-page">
			<div className="auth-box">
				<div className="auth-box-head">
					<div className="auth-brand">
						<img src={logo} alt="Mison" />
						<span>Mison</span>
					</div>
				</div>

				<h1 className="auth-title">{t('recover_your_password')}</h1>
				<div className="auth-subtitle">
					{show ? t('forgot_password_hint2') : t('forgot_password_hint')}
				</div>

				<form autoComplete="off" onSubmit={(e) => handleSubmit(e)}>
					{error &&
						<div className="auth-alert">
							<i className="uil uil-exclamation-circle"></i>
							<span>{error}</span>
						</div>
					}

					<div className="auth-field">
						<label className="auth-label" htmlFor="forgot-login">{t('login')}</label>
						<div className="auth-input-wrap">
							<i className="uil uil-user"></i>
							<input className={`auth-input ${error ? 'is-invalid' : ''}`}
								id="forgot-login"
								name="login"
								autoFocus
								spellCheck={false}
								autoComplete="off"
								disabled={show}
								value={user.login}
								onChange={(e) => updateUser('login', regexLogin(e.target.value))} />
						</div>
					</div>

					{show &&
						<>
							<div className="auth-field">
								<label className="auth-label" htmlFor="forgot-code">{t('code')}</label>
								<div className="auth-input-wrap">
									<i className="uil uil-message"></i>
									<input className="auth-input"
										id="forgot-code"
										name="otp"
										autoFocus
										inputMode="numeric"
										autoComplete="off"
										value={user.otp}
										onChange={(e) => updateUser('otp', e.target.value)} />
								</div>
							</div>

							<div className="auth-field">
								<label className="auth-label" htmlFor="forgot-password">{t('new_password')}</label>
								<div className="auth-input-wrap">
									<i className="uil uil-lock-alt"></i>
									<input className="auth-input auth-input-password"
										id="forgot-password"
										name="password"
										type={showPassword ? "text" : "password"}
										autoComplete="off"
										value={user.password}
										onChange={(e) => updateUser('password', e.target.value)} />
									<button type="button"
										className="auth-eye"
										tabIndex={-1}
										title={showPassword ? t('hide_password') : t('show_password')}
										aria-label={showPassword ? t('hide_password') : t('show_password')}
										onClick={() => setShowPassword(!showPassword)}>
										<i className={`uil ${showPassword ? 'uil-eye-slash' : 'uil-eye'}`}></i>
									</button>
								</div>
							</div>
						</>
					}

					<button type="submit" className="auth-submit" disabled={loading}>
						{loading &&
							<span className="spinner-border spinner-border-sm" role="status"></span>
						}
						{show ? t('change_password') : t('get_activation_code')}
					</button>

					<Link to="/auth/login" className="auth-link">{t('logging_in')}</Link>
				</form>

				<div className="auth-box-foot">
					<span className="auth-foot-btn">
						<i className="uil uil-info-circle"></i>
						<span>{t('contact_centre')}</span>
					</span>
					<a className="auth-foot-btn" href="tel:+998787070089">
						<i className="uil uil-headphones-alt"></i>
						<span>+998 78 707-00-89</span>
					</a>
				</div>
			</div>

			<div className="auth-legal">
				{t('made_by_as')} <br />
				{t('made_by_as2')}
			</div>
		</div>
	)
}

export default ForgotPassword
